(function () {
  const header = document.querySelector('header-component, [role="banner"], .header');
  if (!header) return;

  let ticking = false;

  function lockLogo() {
    // no-op: logo locking handled by CSS only
  }

  function handleScroll() {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      if (window.scrollY > 50) {
        header.classList.add('header--komfy-scrolled');
      } else {
        header.classList.remove('header--komfy-scrolled');
      }
      lockLogo();
      ticking = false;
    });
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
})();
